<!-- Projects view -->
<template>
  <v-container fluid>
    <v-row align="center" justify="space-around">
      <!-- TODO: THE CARD FOR THE LIST OF CONTRIBUTORS -->
      <v-col justify="center" cols="12">
        <v-container>
          <v-layout class="ml-10">
            <v-col cols="5">
              <v-row>
                <v-flex xs4>
                  <v-combobox
                    label="Filtrar por"
                    :items="filter_items"
                    v-model="filter_by"
                    @change="reorder()"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    label="Buscar"
                    v-model="search_value"
                    @change="filterList()"
                  ></v-text-field>
                </v-flex>
              </v-row>
              <v-row aling="center" justify="center">
                <v-btn text small color="black" @click="cleanFilter"
                  >Limpiar Filtro</v-btn
                >
              </v-row>
            </v-col>
            <v-col cols="5">
              <v-flex xs7>
                <v-combobox
                  v-model="order_by"
                  label="Ordenar por"
                  :items="order_items"
                  @change="orderList()"
                />
              </v-flex>
            </v-col>
            <v-col cols="1">
              <v-flex xs5>
                <v-btn
                  small
                  color="primary"
                  class="content"
                  @click="
                    changePage(getProject.project_id, getProject.visibility)
                  "
                  >Continuar</v-btn
                >
              </v-flex>
            </v-col>
          </v-layout>
          <v-card>
            <v-row>
              <v-card
                style="width:100%"
                class="black--text py-12"
                v-for="user in arrayOrder.slice(first_index, second_index)"
                v-bind:key="user.full_name"
                max-height="500"
              >
                <v-row >
                  <v-col cols="3" align="center" justify="center">
                    <v-img
                      src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
                      style="margin-center: 10px;"
                      height="115px"
                      contain
                    />
                  </v-col>
                  <v-col cols="5">
                    <div>
                      <div
                        style="cursor:pointer;"
                        class="mr-4 text-justify hyphens title"
                      >
                        {{ user.full_name }}
                      </div>
                      <div>Instituto: {{ user.institute }}</div>
                      <div v-if="user.tags">
                        <div class="body-1" v-if="filterTag(user.tags) != ''">
                          <v-icon size="15px">mdi-tag</v-icon>
                          {{ filterTag(user.tags) }}
                        </div>
                      </div>
                    </div>
                    <div v-if="!user.tags">  </div>
                  </v-col>
                  <v-col cols="2">
                    <div v-if="user.recommended && !isProjectPending(user.projectsPending)">RECOMENDADO</div>
                    <div v-if="user.contributor && !isProjectPending(user.projectsPending)">CONTRIBUIDOR</div>
                  </v-col>
                  <v-col cols="2" align="center" justify="end">
                    <div v-if="isProjectPending(user.projectsPending)"><h4>PENDIENTE</h4></div>
                    <div v-else-if="user.contributor">
                      <v-btn @click="removeContributor(user)">
                        <v-icon>{{ "mdi-account-multiple-minus" }}</v-icon>
                      </v-btn>
                    </div>
                    <div v-else>
                      <v-btn @click="addContributor(user)">
                        <v-icon>{{ "mdi-account-multiple-plus" }}</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>
          </v-card>
        </v-container>
        <v-layout wrap>
          <v-flex xs8>
            <v-pagination
              v-model="page"
              class="my-4"
              :length="length_page"
              total-visible="7"
              @next="getCorrectList(page)"
              @previous="getCorrectList(page)"
            />
          </v-flex>
          <v-flex xs2>
            <v-combobox
              v-model="len_list"
              label="Proyectos por página"
              :items="items"
              @change="changeLenList"
            />
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>

    <!--SnackBar for errors-->
    <v-snackbar v-model="snackbar" :right="true" :timeout="3000" :top="true">
      Elija un proyecto para continuar
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { firestore } from "firebase";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      project_id: "",
      allUsers: [],
      recommended: [],
      contributors: [],
      pendingContributors: [],
      //Ordenamiento
      arrayOrder: [],
      order_items: [
        "Nombres A-Z",
        "Nombres Z-A",
        "Institución A-Z",
        "Institución Z-A"
      ],
      order_by: "Nombres A-Z",
      // Filtrado
      filter_items: [
        "Nombres",
        "Institución",
        "Etiquetas",
        "Sin Filtro",
        "Recomendados"
      ],
      filter_by: "",
      search_value: "", //Valor de filtrado
      // Paginación
      page: 1,
      length_page: 0,
      len_list: 10,
      items: [5, 10, 20, 50],
      //indices de paginacion
      first_index: 0,
      second_index: 0,
      snackbar: false
    };
  },

  computed: {
    ...mapGetters("projects", ["getProject"])
  },

  beforeDestroy() {
    

    this.pendingContributors.forEach(user => {
      const mail = user.email.primary;
      // envio de correo
      fetch(
        `http://localhost:5000/smartparcitipa-dev/us-central1/send_mail?data=${mail.trim()}-true-${this.getProject.title}`
      )
        .then(Response => Response)
        .then(
          // eslint-disable-next-line no-console
          console.log("El correo ha sido enviado al usuario: ", mail.trim())
        )
        // eslint-disable-next-line no-console
        .catch(err => console.error(err));
      
      firestore()
        .collection('User')
        .doc(user.id)
        .set(user, { merge: true })
        // eslint-disable-next-line no-console
        .then(() => console.log("Usuario ", user.id, " actualizado correctamente.."))
        // eslint-disable-next-line no-console
        .catch(err => console.error(err));
    });
    
    firestore()
      .collection("Project")
      .doc(this.project_id)
      .set(
        {
          contributors: this.contributors,
          recommendedContributors: this.recommended,
          pendingContributors: this.pendingContributors
        },
        { merge: true }
      )
      .then(() => {
        // eslint-disable-next-line no-console
        console.log("Los datos fueron guardados");
      })
      .catch(() => {
        // eslint-disable-next-line no-console
        console.log("No se guardo los nuevos contribuidores");
      }); 
   
  },

  mounted() {
    this.onceProject();
    this.project_id = this.$route.params.project_id;
    this.filter_by = "Nombres";

    //Get all users on database
    firestore()
      .collection("User")
      .orderBy("first_name", "asc")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          let data = doc.data();
          data.id = doc.id;
          let first_name = data.first_name ? data.first_name : "";
          let last_name = data.last_name ? data.last_name : "";
          let full_name_user = first_name + " " + last_name;
          data.full_name = full_name_user.trim();
          let education = data.education;
          if (education) {
            data.institute = data.education[0]
              ? data.education[0].organization
              : "Desconocido";
          } else {
            data.institute = "Desconocido";
          }
          data.id = doc.id;
          const filterObj = this.allUsers.filter(
            user => user.full_name === data.full_name
          );
          if (!filterObj.length) this.allUsers.push(data);
        });

        this.addRecommendedAndContibutorPeople();
        this.recommended = this.getProject.recommendedContributors
          ? [...this.getProject.recommendedContributors]
          : [];
        this.arrayOrder = [...this.allUsers];
        this.changeLenList();
      });
  },

  methods: {
    ...mapActions("projects", ["onceProject"]),

    isProjectPending(pending) {
      const projectId = this.$route.params.project_id;

      if (!pending || !pending.length) return false

      const filterObj = pending.filter(e => e.id === projectId);
      if (filterObj.length) {
        // eslint-disable-next-line no-console
        console.log("Pendig: ", pending);
        return filterObj[0].pending;
      }else 
        return false;
    },

    addRecommendedAndContibutorPeople() {
      let copyUsers = [...this.allUsers];
      let isContributorSet = false;

      copyUsers.forEach(user => {
        if(this.isProjectPending(user.projectsPending)){
          this.allUsers.splice(0, 0, user);
        }
        else if (
          this.getProject.recommendedContributors &&
          this.getProject.recommendedContributors.length
        ) {
          const filterObj = this.getProject.recommendedContributors.filter(
            e => e === user.id
          );

          if (filterObj.length) {
            this.allUsers.splice(this.allUsers.indexOf(user), 1);
            user.recommended = true;
            this.allUsers.splice(isContributorSet ? 1 : 0, 0, user);
          }
        }

        else if (
          this.getProject.contributors &&
          this.getProject.contributors.length
        ) {
          const filterObjC = this.getProject.contributors.filter(
            e =>
              e.full_name === user.full_name && e.email === user.email.primary
          );
          if (filterObjC.length) {
            this.allUsers.splice(this.allUsers.indexOf(user), 1);
            user.contributor = true;
            isContributorSet = true;

            this.contributors.push({
              full_name: user.full_name,
              email: user.email.primary
            });
            this.allUsers.splice(0, 0, user);
          }
        }
      });
    },

    changePage(project_id, visibility) {
      this.$router.push({
        path: `/dashboard/${project_id}/${visibility}`
      });
    },
    filterTag(tag) {
      if (tag.length > 0) {
        return tag.reduce((x, y) => {
          return x + ", " + y;
        });
      } else {
        return "";
      }
    },
    getCorrectList(page) {
      this.second_index = page * this.len_list;
      this.first_index = this.second_index - this.len_list;
    },
    changeLenList() {
      this.page = 1;
      this.length_page = Math.ceil(this.arrayOrder.length / this.len_list);
      this.getCorrectList(this.page);
    },
    orderList() {
      const arrayCopy = [...this.allUsers];

      if (this.order_by === "Nombres A-Z") {
        arrayCopy.sort((a, b) =>
          a.full_name > b.full_name ? 1 : b.full_name > a.full_name ? -1 : 0
        );
      }
      else if (this.order_by === "Nombres Z-A") {
        arrayCopy.sort((a, b) =>
          a.full_name < b.full_name ? 1 : b.full_name < a.full_name ? -1 : 0
        );
      } else if (this.order_by === "Institución A-Z") {
        arrayCopy.sort((a, b) =>
          a.institute > b.institute ? 1 : b.institute > a.institute ? -1 : 0
        );
      } else if (this.order_by === "Institución Z-A") {
        arrayCopy.sort((a, b) =>
          a.institute < b.institute ? 1 : b.institute < a.institute ? -1 : 0
        );
      }
      this.arrayOrder = arrayCopy;
      this.getCorrectList(this.page);
      this.changeLenList();
    },
    filterList() {
      let filter_array = [];

      this.arrayOrder.filter(user => {
        if (this.filter_by == "Nombres") {
          let pos = user.full_name
            .toLowerCase()
            .indexOf(this.search_value.toLowerCase());
          if (pos >= 0 && !filter_array.find(e => e === user)) filter_array.push(user);
        } else if (this.filter_by == "Institución") {
          let pos = user.institute
            .toLowerCase()
            .indexOf(this.search_value.toLowerCase());
          if (pos >= 0 && !filter_array.find(e => e === user))
            filter_array.push(user);
        } else if (this.filter_by == "Etiquetas") {
          if (user.tags){
            let pos = user.tags
              .toString()
              .toLowerCase()
              .indexOf(this.search_value.toLowerCase());
            if (pos >= 0 && !filter_array.find(e => e === user))
              filter_array.push(user);
          }
        } else if (this.filter_by == "Sin Filtro") {
          this.cleanFilter();
        } else if (this.filter_by == "Recomendados") {
          if (user.recommended) {
            filter_array.push(user);
          }
        }
      });

      this.arrayOrder = filter_array;
      this.changeLenList();
    },
    cleanFilter() {
      this.filter_by = "Sin Filtro";
      this.search_value = "";
      this.orderList();
      //this.arrayOrder = this.allUsers;
    },

    reorder() {
      this.search_value = "";
      if (this.filter_by == "Recomendados") {
        this.filterList();
      }
    },

    removeContributor(user) {
      this.allUsers.pop(user);
      delete user.contributor;
      this.allUsers.push(user);

      this.arrayOrder = [...this.allUsers];
      
      let i = 0;
      for (let cont in this.contributors) {
        if (cont.full_name === user.full_name) {
          i = this.contributors.indexOf(cont);
          break;
        }
      }
      this.contributors.splice(i, 1);
    },

    addContributor(user) {
      const projectId = this.$route.params.project_id;
      if (user.projectsPending ) {
        // eslint-disable-next-line no-console
        console.log("Pendientes: ", user.projectsPending);
        user.projectsPending.push({
          id: projectId,
          name: this.getProject.title,
          pending: true
        });
      } else {
        user.projectsPending = [{
          id: projectId,
          name: this.getProject.title,
          pending: true
          }]
      }
      
      for (let userD of this.allUsers) {
        if (userD.full_name === user.full_name) {
          if (userD.recommended) {
            // eslint-disable-next-line no-console
            console.log("this.recommended");
            userD.recommended = false;
          }
          break;
        }
      };
      
      this.arrayOrder = [...this.allUsers];
      this.getCorrectList(this.page);
      this.changeLenList();
      this.pendingContributors.push({ ...user });
      /*
      this.contributors.push({
        full_name: user.full_name,
        email: user.email.primary,
      });*/
    }
  }
};
</script>
